var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.is_open)?_c('div',{staticClass:"modal__container",on:{"click":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"img__container"},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":"modal-img"}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }